import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import MaintenancePageSplitsReportCriteria from './MaintenancePageSplitsReportCriteria';

@NeoReport("MaintenancePageSplits",  { category: MaintenanceReportCategories.SystemInformationReports})
export default class MaintenancePageSplitsReport extends Report<MaintenancePageSplitsReportCriteria>{
    constructor() {
        super(MaintenancePageSplitsReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
        </>
        );
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}